<app-titledescription [title]="'Planes'" [description]="'Aca se muestra el listado de planes.'"></app-titledescription>
<app-button
		text="Agregar Plan"
		tooltip="Agregar nuevo plan"
		href="/planes/create"
></app-button>
<div style="margin-bottom: 20px;"></div>
<ng-template #table>
@if(dataFetch) {
	<app-table
		[columnsNames]="columnNames"
		[dataFetch]="dataFetch"
		[totalItems]="totalItems"
		(fetchAgain)="fetchData($event.options, $event.ignoreCache)"
    [actions]="actions"
		[filterable]="true"
    [selectable]="true"
    [dataSelect]="dataSelectNiveles"
    [actions]="actions"
    [labelFilter]="'descripcion'"
    [apiService]="apiService"
    [paginateOptions]="paginateOptions"
    [pageIndex]="pageIndex"
    [apiService]="apiService"
    [labelSelect]="'Nivel'"
    [mainFilterField]="'nivel_id'"
	></app-table>
}
</ng-template>
<app-card [templateRefContent]="table"></app-card>
